import { getGalleryFiles} from '../repositories/upload.repository'

const state = {
    galleryFiles: []
}

const actions = {
    getGalleryFiles ({ commit }) {
        return new Promise(resolve => getGalleryFiles()
            .then(res => {
                commit('setGalleryFiles', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
}

const mutations = {
    setGalleryFiles (state, files) {
        state.galleryFiles = files
    }
}

export default {
    state,
    actions,
    mutations
}